import { useBusinessContext } from "@/context/BusinessContext";

/**
 * @deprecated Use useBusinessContext from '@/context/BusinessContext' instead.
 * This hook is maintained for backward compatibility only.
 *
 * Migration guide:
 * - Replace `useBusinesses()` with `useBusinessContext()`
 * - Replace `setSelectedBusinessId(id)` with `switchBusiness(id)` for proper query invalidation
 */
export function useBusinesses() {
  const context = useBusinessContext();

  return {
    businesses: context.businesses,
    setBusinesses: context.setBusinesses,
    updateBusinessInList: context.updateBusinessInList,
    loadingBusinesses: context.loadingBusinesses,
    selectedBusinessId: context.selectedBusinessId,
    // Map to switchBusiness for backward compatibility
    // Note: switchBusiness also invalidates queries, which is an improvement
    setSelectedBusinessId: context.switchBusiness,
  };
}
